import React from 'react';
import PrimaryButtonLink from '../components/PrimaryButtonLink';
import PageSection from '../components/PageSection';

const TalentStrategy = () => {
  return (
    <>
      <section className="hero hero-secondary">
        <div className="container hero-inner">
          <p className="eyebrow">Talent Strategy 2026</p>
          <h1>Risorse as-a-Service per scalare il talento senza attriti.</h1>
          <p className="hero-subtitle">
            Un framework operativo che trasforma il modello tradizionale di
            assunzione in una strategia liquida: veloce, misurabile e pronta per
            il board.
          </p>
          <div className="hero-actions">
            <PrimaryButtonLink to="/contatti">
              Parla con un advisor
            </PrimaryButtonLink>
            <PrimaryButtonLink to="/metodo" variant="ghost">
              Scopri il metodo
            </PrimaryButtonLink>
          </div>
        </div>
      </section>

      <PageSection
        title="Framework operativo: Talent Strategy 2026"
        intro="Confronto tra assunzione diretta (FTE) e Resource-as-a-Service (RaaS) per decidere con criteri di business, non di abitudine."
      >
        <div className="comparison-table-card">
          <table className="comparison-table">
            <thead>
              <tr>
                <th>Dimensione</th>
                <th>Modello Tradizionale (Internal Hiring)</th>
                <th className="highlight">Modello Liquido (RaaS / Talent-as-a-Service)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Time-to-Market</strong></td>
                <td>Lento: 3-6 mesi tra ricerca, selezione e onboarding.</td>
                <td className="highlight">Immediato: team o specialisti pronti in 1-2 settimane.</td>
              </tr>
              <tr>
                <td><strong>Struttura Costi</strong></td>
                <td>Fissa (CAPEX-like): stipendi, benefit, tasse, hardware, uffici.</td>
                <td className="highlight">Variabile (OPEX): pay-per-use, scalabile in base al budget e ai task.</td>
              </tr>
              <tr>
                <td><strong>Aggiornamento Skill</strong></td>
                <td>Statico: dipende dalla formazione interna (costosa e lenta).</td>
                <td className="highlight">Dinamico: accesso immediato a competenze di frontiera (AI, Cyber, Cloud).</td>
              </tr>
              <tr>
                <td><strong>Rischio Operativo</strong></td>
                <td>Alto: dimissioni = perdita totale di conoscenza e blocco progetti.</td>
                <td className="highlight">Basso: continuita garantita dal provider (knowledge transfer nativo).</td>
              </tr>
              <tr>
                <td><strong>Flessibilita</strong></td>
                <td>Rigida: difficile ridurre il team in fasi di stanca.</td>
                <td className="highlight">Elastica: scalabilita immediata (up & down) senza attriti legali.</td>
              </tr>
              <tr>
                <td><strong>Focus Manageriale</strong></td>
                <td>Micro-management: ferie, carriere, conflitti interni.</td>
                <td className="highlight">Governance: gestione output, qualita e obiettivi.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </PageSection>

      <PageSection
        title="Come implementare il modello As-a-Service"
        intro="Non e body rental: e un nuovo operating model per velocita, qualita e scalabilita."
      >
        <div className="framework-grid">
          <article className="framework-card">
            <h3>1. Team ibrido (Core + Satellite)</h3>
            <p>
              Un core interno ad altissimo livello governa visione e dati, mentre
              team satellite si innestano su obiettivi verticali.
            </p>
            <ul>
              <li>Core team: strategia, dati critici, ownership di prodotto.</li>
              <li>Satellite teams: missioni specialistiche e time-boxed.</li>
              <li>Ambiti tipici: mobile, AI, cloud migration, sicurezza.</li>
            </ul>
          </article>

          <article className="framework-card">
            <h3>2. Developer Experience standardizzata</h3>
            <p>
              Come in un servizio cloud: onboarding plug-and-play dal giorno 1.
            </p>
            <ul>
              <li>Pipeline CI/CD automatizzate e ambienti pronti.</li>
              <li>Documentazione living e standard condivisi.</li>
              <li>Metriche di qualita visibili e condivise.</li>
            </ul>
          </article>

          <article className="framework-card">
            <h3>3. Dal costo orario al valore consegnato</h3>
            <p>
              Paghi per milestone certificate, non per presenza in ufficio.
            </p>
            <ul>
              <li>Pricing value-based legato a risultati misurabili.</li>
              <li>Milestone: API documentata, test passati, modulo live.</li>
              <li>Allineamento pieno tra budget e output.</li>
            </ul>
          </article>
        </div>
      </PageSection>

      <PageSection title="Messaggio chiave per il board">
        <div className="statement-card">
          <p>
            Oggi non compriamo piu server perche vogliamo scalabilita
            computazionale. Allo stesso modo, non dovremmo piu solo assumere
            persone se vogliamo scalabilita creativa e produttiva. Le persone
            devono essere l'intelligenza che governa il servizio, non
            l'ingranaggio che lo tiene in vita.
          </p>
        </div>
      </PageSection>

      
    </>
  );
};

export default TalentStrategy;
